import React from "react";

const Cover = ({ url }) => {
  return (
    <div
      className='cover h-full w-full'
      style={{
        background: `url(${url})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat"
      }}></div>
  );
};

export default Cover;
